export const PROFILES_ROUTE = '/profiles';
